import { Protocol } from '@orbital/games-frontend-library'
import { sendStakes } from '../settings/useSettings'

export const useTexasSocketMessages = (sendSocketMessage: any) => {
  const handleDeal = (ante: string) => {
    sendStakes(ante)
    sendSocketMessage(Protocol.START_ROUND, ante.toString(), '0')
  }
  const handleFold = () => sendSocketMessage(Protocol.END_ROUND)
  const handleRaise = () => sendSocketMessage(Protocol.STEP_ROUND, 'bet')
  const handleBet = () => sendSocketMessage(Protocol.STEP_ROUND, 'bet')
  const handleCheck = () => sendSocketMessage(Protocol.STEP_ROUND, 'check')

  return {
    handleDeal,
    handleRaise,
    handleFold,
    handleBet,
    handleCheck,
  }
}
